import script from "./Kpis.vue?vue&type=script&setup=true&lang=ts"
export * from "./Kpis.vue?vue&type=script&setup=true&lang=ts"

import "./Kpis.vue?vue&type=style&index=0&id=076808f8&lang=scss"

const __exports__ = script;

export default __exports__